import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { goToGuardianHub } from "../utils/appNavigation";

/**
 * Bloqueia rotas Guardian restritas (criar alerta, boas-vindas)
 * para usuários PROP / GUARDIAN — redireciona ao hub.
 */
export default function GuardianRestrictedRoute({
  allowed,
  children,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.user.currentUser);

  const isAllowed =
    !currentUser
      ? null
      : typeof allowed === "function"
        ? allowed(currentUser)
        : Boolean(allowed);

  useEffect(() => {
    if (isAllowed === false) {
      goToGuardianHub(dispatch, navigate, { replace: true });
    }
  }, [isAllowed, dispatch, navigate]);

  if (!currentUser || isAllowed === null) return null;
  if (!isAllowed) return null;
  return children;
}
